import { ICardDeliverySendPaymentUI } from './types'

import imgEmty from '@img/empty.svg'
import { IconClearClose } from '@img/icons'

import { Button, Divider, Empty, Flex, Loader, Modal, Table } from '@ui/index'


/** UI отправки счёта в telegram */
export const CardDeliverySendPaymentUI = ({
    isOpen, loadingTitle, isLoadingFiles, filesList, createList,

    handleSelectedFiles, handleSelectedPayment,
    handleBtnSend, handleBtnCancel
}: ICardDeliverySendPaymentUI) => {
    return <Modal isOpen={isOpen} isEsc isWrapper onCancel={handleBtnCancel} maxWidth="400px">
        <Flex className='modal_container'>
            <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                <h4>Отправка счёта</h4>

                <Button variant='icon' size='xs' onClick={handleBtnCancel}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Flex gap='14px' className='modal_container-content'>
                    <Loader isOpen={isLoadingFiles} backdrop color='#f34e2e' title={loadingTitle.value} />

                    <Flex gap='4px'>
                        <Divider prefix={<h4>Имеющиеся счета</h4>} />
                        <Table.Content isScrollVertical={false}>
                            {filesList.value.length === 0
                                ? <Empty image={imgEmty} size='50px' title="Счета отсутствуют" />
                                : filesList.value.map((item, index) => {
                                    return (
                                        <Table.RowCheckBox key={index} isSelected={item.isSelect} header={<IconClearClose width='18px' height='18px' />} onClick={(e) => handleSelectedFiles(item.name)}>
                                            <p>{item.name}</p>
                                        </Table.RowCheckBox>
                                    )
                                })
                            }
                        </Table.Content>
                    </Flex>
                    
                    <Flex>
                        <Divider prefix={<h4>Или создать</h4>} />
                        <Table.Content isScrollVertical={false}>
                            {createList.value.length === 0
                                ? <Empty image={imgEmty} size='50px' />
                                : createList.value.map((item, index) => {
                                    return (
                                        <Table.RowCheckBox key={index} isSelected={item.isSelect} header={<IconClearClose width='18px' height='18px' />} onClick={(e) => handleSelectedPayment(item.id)}>
                                            <p>{item.name}</p>
                                        </Table.RowCheckBox>
                                    )
                                })
                            }
                        </Table.Content>
                    </Flex>
                </Flex>

                <Button onClick={handleBtnSend}>Отправить выбранное</Button>
            </Flex>
        </Flex>
    </Modal>
}